import Chat from "../components/student/Chat";
import StudentDashboardLayout from "../components/StudentDashboardLayout";
function StudentChat(){
  return(
    <StudentDashboardLayout>
      <Chat/>
      
    </StudentDashboardLayout>
  )
}
export default StudentChat